import { FormConditionRule } from '../FormCondition';
import { useEffect, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

interface useFormConditionProps {
	rules: FormConditionRule[] | undefined;
}

export default function useFormCondition(props: useFormConditionProps) {
	const { rules } = props;
	const { watch } = useFormContext();
	const watchAll = watch();

	const validateRule = (ruleItem: FormConditionRule): boolean => {
		const { formControlKey, rule, value } = ruleItem;

		const formControlValue = watch(formControlKey);

		const realValue =
			formControlValue?.value?.code ??
			formControlValue?.secondaryValue ??
			formControlValue?.value ??
			formControlValue;

		switch (rule) {
			case 'filled':
				return !!realValue;
			case 'equal':
				return realValue === value;
			case 'notEqual':
				return realValue !== value;
			case 'in':
				return value.indexOf(realValue) !== -1;
			case 'startsWith':
				return [...(Array.isArray(value) ? value : [value])].some(val =>
					(realValue ?? '').startsWith(val),
				);
			case 'notStartsWith':
				return [...(Array.isArray(value) ? value : [value])].every(
					val => !(realValue ?? '').startsWith(val),
				);
		}
	};

	const result = useMemo(() => {
		let tempResult = true;

		if (!rules) {
			return tempResult;
		}

		for (const rule of rules) {
			tempResult = validateRule(rule);

			if (!tempResult) {
				break;
			}
		}

		return tempResult;
	}, [rules, watchAll]);
	return {
		result,
	};
}
